// AREI componenttypes voor eendraadschema + situatieplan (Trikker-stijl)

export const CONSUMER_TYPES = [
  { value: 'pv_string', label: 'PV string (zonnepanelen)', short: 'PV' },
  { value: 'omvormer', label: 'Omvormer', short: 'INV' },
  { value: 'batterij', label: 'Batterij', short: 'BAT' },
  { value: 'backup', label: 'Back-up (ATS)', short: 'ATS' },
  { value: 'verdeelbord', label: 'Verdeelbord', short: 'VB' },
  { value: 'kabel', label: 'Kabel (segment)', short: 'KAB' },
  { value: 'kwh_meter', label: 'kWh-meter', short: 'kWh' },
  { value: 'aarding', label: 'Aarding', short: 'PE' },
  { value: 'stopcontact', label: 'Stopcontact', short: 'SC' },
  { value: 'stopcontact_dubbel', label: 'Dubbel stopcontact', short: '2×SC' },
  { value: 'lichtpunt', label: 'Lichtpunt', short: 'LP' },
  { value: 'led_spot', label: 'LED spot', short: 'LED' },
  { value: 'schakelaar', label: 'Schakelaar (enkel)', short: 'S1' },
  { value: 'schakelaar_dubbel', label: 'Schakelaar (dubbel)', short: 'S2' },
  { value: 'wisselschakelaar', label: 'Wisselschakelaar', short: 'WS' },
  { value: 'drukknop', label: 'Drukknop', short: 'DK' },
  { value: 'boiler', label: 'Boiler', short: 'B' },
  { value: 'vaatwas', label: 'Vaatwasser', short: 'VW' },
  { value: 'wasmachine', label: 'Wasmachine', short: 'WM' },
  { value: 'droogkast', label: 'Droogkast', short: 'DR' },
  { value: 'oven', label: 'Oven', short: 'OV' },
  { value: 'kookplaat', label: 'Kookplaat', short: 'KP' },
  { value: 'koelkast', label: 'Koelkast', short: 'KK' },
  { value: 'laadpaal', label: 'Laadpaal', short: 'EV' },
  { value: 'airco', label: 'Airco / warmtepomp', short: 'AC' },
  { value: 'ventilatie', label: 'Ventilatie', short: 'VE' },
  { value: 'bel', label: 'Bel / parlofoon', short: 'BEL' },
];

export const consumerLabel = (v) => CONSUMER_TYPES.find(c => c.value === v)?.label || v;

export const CABLE_OPTIONS = ['3G1,5', '3G2,5', '3G4', '3G6', '3G10', '4G10', '4G16', '5G1,5', '5G2,5', '5G4', '5G6', '5G10',
  'XVB Cca 3G2,5', 'XVB Cca 4x10', 'XVB Cca 5G6', 'XGB Cca 5G4', 'XGB Cca 5G6', 'EXVB 5G16',
  'Solar 2x4 + PE 1x4', 'Solar 2x6 + PE 1x6', '3G4 (batt)'];
export const BREAKER_AMPS = [2, 6, 10, 16, 20, 25, 32, 40, 63];
export const BREAKER_CURVES = ['B', 'C', 'D'];
export const KA_OPTIONS = ['3000', '6000', '10000'];
export const DIFF_MILLIAMPS = [30, 100, 300];
export const DIFF_AMPS = [40, 63];
export const DIFF_TYPES = ['A', 'B', 'AC'];

// AREI-symbolen, getekend rond (0,0). Stijl: dunne zwarte lijnen zoals Trikker.
export function EendraadSymbol({ type, size = 26, width }) {
  const s = size;
  const st = { stroke: 'currentColor', strokeWidth: 1.4, fill: 'none' };
  switch (type) {
    case 'pv_string':
      // Staande rechthoek met driehoek onderin (Trikker PV-symbool)
      return (
        <g {...st}>
          <rect x={-s / 3} y={-s / 1.6} width={s / 1.5} height={s * 1.25} />
          <path d={`M ${-s / 3} ${s * 0.63} L 0 ${-s / 10} L ${s / 3} ${s * 0.63} Z`} />
        </g>
      );
    case 'batterij':
      // Batterijcellen: lang-kort strepen
      return (
        <g {...st}>
          <line x1={-s / 2.2} y1={-s / 3.5} x2={s / 2.2} y2={-s / 3.5} strokeWidth={2} />
          <line x1={-s / 4.5} y1={-s / 8} x2={s / 4.5} y2={-s / 8} strokeWidth={1.2} />
          <line x1={-s / 2.2} y1={s / 8} x2={s / 2.2} y2={s / 8} strokeWidth={2} />
          <line x1={-s / 4.5} y1={s / 3.5} x2={s / 4.5} y2={s / 3.5} strokeWidth={1.2} />
        </g>
      );
    case 'thuisbatterij': {
      // Thuisbatterij: omvormer met batterijcellen er direct achter (boven) op de lijn
      const w = Math.max(width || s * 1.45, s * 1.45);
      return (
        <g {...st}>
          <rect x={-w / 2} y={-s / 2.2} width={w} height={s / 1.1} />
          <line x1={-w / 2} y1={s / 2.2} x2={w / 2} y2={-s / 2.2} />
          <path transform={`translate(${w / 2 - s * 0.63}, 0)`} d={`M ${s / 4} ${-s / 5} q ${s / 12} ${-s / 8} ${s / 6} 0 q ${s / 12} ${s / 8} ${s / 6} 0`} />
          <line x1={-w / 2 + s * 0.16} y1={s / 6} x2={-w / 2 + s * 0.46} y2={s / 6} />
          <line x1={-w / 2 + s * 0.16} y1={s / 3.4} x2={-w / 2 + s * 0.46} y2={s / 3.4} />
          <line x1={0} y1={-s / 2.2} x2={0} y2={-s * 1.2} />
          <g transform={`translate(0, ${-s * 1.5})`}>
            <line x1={-s / 2.2} y1={-s / 3.5} x2={s / 2.2} y2={-s / 3.5} strokeWidth={2} />
            <line x1={-s / 4.5} y1={-s / 8} x2={s / 4.5} y2={-s / 8} strokeWidth={1.2} />
            <line x1={-s / 2.2} y1={s / 8} x2={s / 2.2} y2={s / 8} strokeWidth={2} />
            <line x1={-s / 4.5} y1={s / 3.5} x2={s / 4.5} y2={s / 3.5} strokeWidth={1.2} />
          </g>
        </g>
      );
    }
    case 'omvormer': {
      // Rechthoek met diagonaal, ~ (AC) boven, = (DC) onder; breedte schaalt mee met aantal takken
      const w = Math.max(width || s * 1.45, s * 1.45);
      return (
        <g {...st}>
          <rect x={-w / 2} y={-s / 2.2} width={w} height={s / 1.1} />
          <line x1={-w / 2} y1={s / 2.2} x2={w / 2} y2={-s / 2.2} />
          <path transform={`translate(${w / 2 - s * 0.63}, 0)`} d={`M ${s / 4} ${-s / 5} q ${s / 12} ${-s / 8} ${s / 6} 0 q ${s / 12} ${s / 8} ${s / 6} 0`} />
          <line x1={-w / 2 + s * 0.16} y1={s / 6} x2={-w / 2 + s * 0.46} y2={s / 6} />
          <line x1={-w / 2 + s * 0.16} y1={s / 3.4} x2={-w / 2 + s * 0.46} y2={s / 3.4} />
        </g>
      );
    }
    case 'backup':
      // ATS: kader met "ATS"
      return (
        <g {...st}>
          <rect x={-s / 1.5} y={-s / 2.6} width={s * 1.33} height={s / 1.3} />
          <text x={0} y={s / 8} textAnchor="middle" fontSize={s / 2.9} fill="currentColor" stroke="none">ATS</text>
        </g>
      );
    case 'laadpaal':
      // AREI laadpaal: laadstation met display, EV, laadsnoer en voetplaat
      return (
        <g {...st}>
          <rect x={-s / 2.4} y={-s / 2} width={s / 1.2} height={s * 0.92} />
          <rect x={-s / 3.6} y={-s / 2.6} width={s / 1.8} height={s / 3.6} />
          <text x={0} y={s / 3.4} textAnchor="middle" fontSize={s / 3.1} fill="currentColor" stroke="none">EV</text>
          <line x1={s / 2.4} y1={-s / 3.2} x2={s / 1.75} y2={-s / 3.2} />
          <line x1={s / 1.75} y1={-s / 3.2} x2={s / 1.75} y2={s / 3} />
          <rect x={s / 1.75 - s / 18} y={-s / 2.3} width={s / 9} height={s / 7} fill="currentColor" stroke="none" />
          <line x1={-s / 1.8} y1={s / 2.1} x2={s / 1.8} y2={s / 2.1} strokeWidth={2.2} />
        </g>
      );
    case 'verdeelbord':
      // Verdeelbord: liggende kast met automaat-streepjes bovenop en aansluiting onderaan
      return (
        <g {...st}>
          <rect x={-s / 1.4} y={-s / 4} width={(s / 1.4) * 2} height={s / 2} />
          {[-0.5, -0.25, 0, 0.25, 0.5].map((f, i) => (
            <line key={i} x1={f * s} y1={-s / 4} x2={f * s} y2={-s / 1.75} />
          ))}
          <line x1={0} y1={s / 4} x2={0} y2={s / 1.75} />
        </g>
      );
    case 'kwh_meter':
      return (
        <g {...st}>
          <rect x={-s / 1.6} y={-s / 2.6} width={s * 1.25} height={s / 1.3} />
          <text x={0} y={s / 8} textAnchor="middle" fontSize={s / 2.6} fill="currentColor" stroke="none">kWh</text>
        </g>
      );
    case 'aarding':
      return (
        <g {...st}>
          <line x1={0} y1={-s / 2.4} x2={0} y2={0} />
          <line x1={-s / 2.4} y1={0} x2={s / 2.4} y2={0} />
          <line x1={-s / 3.6} y1={s / 5.5} x2={s / 3.6} y2={s / 5.5} />
          <line x1={-s / 6.5} y1={s / 3} x2={s / 6.5} y2={s / 3} />
        </g>
      );
    case 'stopcontact':
    case 'stopcontact_dubbel':
      return (
        <g {...st} strokeWidth={1.6}>
          <path d={`M ${-s / 3} 0 A ${s / 3} ${s / 3} 0 0 1 ${s / 3} 0`} />
          <line x1={0} y1={-s / 3} x2={0} y2={-s / 1.6} />
          <line x1={-s / 3} y1={0} x2={s / 3} y2={0} />
          {type === 'stopcontact_dubbel' && <line x1={-s / 4} y1={-s / 2.1} x2={s / 4} y2={-s / 2.1} />}
        </g>
      );
    case 'lichtpunt':
    case 'led_spot':
      return (
        <g {...st} strokeWidth={1.6}>
          <line x1={-s / 4} y1={-s / 4} x2={s / 4} y2={s / 4} />
          <line x1={-s / 4} y1={s / 4} x2={s / 4} y2={-s / 4} />
          {type === 'led_spot' && <circle cx={0} cy={0} r={s / 3.2} />}
        </g>
      );
    case 'schakelaar':
    case 'schakelaar_dubbel':
    case 'wisselschakelaar':
      return (
        <g {...st} strokeWidth={1.6}>
          <circle cx={0} cy={s / 4} r={2} fill="currentColor" />
          <line x1={0} y1={s / 4} x2={s / 2.6} y2={-s / 3} />
          <line x1={s / 2.6} y1={-s / 3} x2={s / 1.9} y2={-s / 4.5} />
          {type === 'schakelaar_dubbel' && <line x1={s / 7} y1={s / 12} x2={s / 2.1} y2={-s / 2.4} />}
          {type === 'wisselschakelaar' && <line x1={0} y1={s / 4} x2={-s / 2.6} y2={-s / 3} />}
        </g>
      );
    case 'drukknop':
      return (
        <g {...st} strokeWidth={1.6}>
          <circle cx={0} cy={0} r={s / 3.2} />
          <circle cx={0} cy={0} r={s / 8} fill="currentColor" />
        </g>
      );
    default:
      return (
        <g {...st}>
          <rect x={-s / 2.2} y={-s / 3.2} width={s / 1.1} height={s / 1.6} />
          <text x={0} y={s / 8} fontSize={s / 3.2} textAnchor="middle" fill="currentColor" stroke="none">
            {CONSUMER_TYPES.find(c => c.value === type)?.short || '?'}
          </text>
        </g>
      );
  }
}

export const WALL_FIXTURES = [
  { value: 'raam', label: 'Raam' },
  { value: 'deur', label: 'Deur' },
  { value: 'garagepoort', label: 'Garagepoort' },
];

// Symbolen die op een muur geplaatst worden (georiënteerd langs de muur)
export function FixtureSymbol({ type, size = 44 }) {
  const s = size;
  const st = { stroke: '#1a1a1a', strokeWidth: 1.6, fill: 'none' };
  switch (type) {
    case 'raam':
      return (
        <g>
          <rect x={-s / 2} y={-5} width={s} height={10} fill="#ffffff" stroke="none" />
          <line x1={-s / 2} y1={-4} x2={s / 2} y2={-4} {...st} />
          <line x1={-s / 2} y1={4} x2={s / 2} y2={4} {...st} />
          <line x1={-s / 2} y1={-4} x2={-s / 2} y2={4} {...st} />
          <line x1={s / 2} y1={-4} x2={s / 2} y2={4} {...st} />
        </g>
      );
    case 'deur':
      return (
        <g>
          <rect x={-s / 2} y={-4} width={s} height={8} fill="#ffffff" stroke="none" />
          <line x1={-s / 2} y1={0} x2={-s / 2} y2={-s} {...st} />
          <path d={`M ${-s / 2} ${-s} A ${s} ${s} 0 0 1 ${s / 2} 0`} {...st} strokeDasharray="3 3" />
        </g>
      );
    case 'garagepoort':
      return (
        <g>
          <rect x={-s / 2} y={-5} width={s} height={10} fill="#ffffff" stroke="none" />
          <line x1={-s / 2} y1={0} x2={s / 2} y2={0} {...st} strokeWidth={2.4} />
          {[-0.375, -0.125, 0.125, 0.375].map((f, i) => (
            <line key={i} x1={f * s} y1={-6} x2={f * s} y2={6} {...st} strokeWidth={1.2} />
          ))}
        </g>
      );
    default:
      return null;
  }
}

export function PlanSymbol({ type, size = 30, circuitNo }) {
  const t = type === 'batterij' ? 'thuisbatterij' : type;
  return (
    <g>
      <EendraadSymbol type={t} size={size} />
      {circuitNo != null && circuitNo !== '' && (
        <text x={size / 2 + 2} y={-size / 3} fontSize={11} fontWeight="bold" fill="#111" stroke="none">{circuitNo}</text>
      )}
    </g>
  );
}
